import history from "App/History"
import { useTypedDispatch } from "App/Store"
import { DEFAULT_API_ERROR } from "core/constants/Defaults"
import { login, signUpUser } from "core/services/Auth"
import { getHomePage } from "core/services/RBAC"
import { clearUser, setToken } from "core/services/Storage"
import { useCallback, useEffect, useMemo } from "react"
import { useLocation } from "react-router-dom"
import { hideLoader, showLoader } from "redux/action/loaderAction"
import { useNotification } from "shared/hooks/useNotification"

export default function Callback() {

  const dispatch = useTypedDispatch()
  const showNotification = useNotification()
  const location = useLocation()
  const query = useMemo(() => new URLSearchParams(location.search), [location.search])

  const handleLogin = useCallback(async (token: string) => {
    dispatch(showLoader())
    const response = await login({ token, loginType: 'gauth' })
    dispatch(hideLoader())
    if (response.status && response.data) {
      setToken(response.data.token)
      const homePage = getHomePage()
      if (homePage) {
        history.replace(homePage)
        showNotification({
          message: `Welcome to the BattleXO HUB`,
          title: 'Success',
          type: 'success'
        })
      } else {
        showNotification({
          message: `Access Denied`,
          title: 'Error',
          type: 'error'
        })
      }
    } else {
      showNotification({
        message: response.message || DEFAULT_API_ERROR,
        title: 'Error',
        type: 'error'
      })
    }
  }, [dispatch, showNotification])

  const handleSignUp = useCallback(async (token) => {
    dispatch(showLoader())
    const signUpRes = await signUpUser({ token, loginType: 'gauth' })
    dispatch(hideLoader())
    if (signUpRes.status) {
      showNotification({
        message: 'User Created Successfully.',
        title: 'Success',
        type: 'success'
      })
    } else {
      showNotification({
        message: signUpRes.message || DEFAULT_API_ERROR,
        title: 'Error',
        type: 'error'
      })
    }
    history.replace('/login')
  }, [dispatch, showNotification])


  useEffect(() => {
    const code = query.get('code')
    const state = query.get('state')
    if (code && state) {
      if (state === 'login') {
        handleLogin(code)
      } else {
        handleSignUp(code)
      }
    } else {
      clearUser()
      history.replace('/login')
    }
  }, [handleLogin, handleSignUp, query])

  return <></>

}
